import {useLocation} from 'react-router';
import {useEffect, useRef} from 'react';
import {setFocus} from '@noriginmedia/norigin-spatial-navigation';

const useEscape = () => {
    const location = useLocation();
    const leftKeyPressCount = useRef(0);
    const resetTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

    const getMenuIdFromPath = (pathname: string): string => {
        const pathToMenuId: {[key: string]: string} = {
            '/streaming': 'streaming',
            '/iptv': 'iptv',
            '/replay': 'replay',
            '/message': 'message',
            '/videoCall': 'videoCall',
            '/busArrived': 'busArrived',
        };

        return pathToMenuId[pathname] || 'streaming';
    };

    const resetCounter = () => {
        leftKeyPressCount.current = 0;
        if (resetTimer.current) {
            clearTimeout(resetTimer.current);
            resetTimer.current = null;
        }
    };

    const handleKeyDown = (event: KeyboardEvent) => {
        if (event.key === 'ArrowLeft' || event.keyCode === 37) {
            leftKeyPressCount.current += 1;

            if (leftKeyPressCount.current === 1) {
                resetTimer.current = setTimeout(() => {
                    resetCounter();
                }, 2000);
            }

            if (leftKeyPressCount.current === 5) {
                const menuId = getMenuIdFromPath(location.pathname);
                setFocus(menuId);
                resetCounter();
                event.preventDefault();
                event.stopPropagation();
            }
        } else {
            resetCounter();
        }
    };

    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown, true);
        return () => {
            document.removeEventListener('keydown', handleKeyDown, true);
            resetCounter();
        };
    }, [location.pathname]);

    useEffect(() => {
        resetCounter();
    }, [location.pathname]);
};

export default useEscape;
